import _ from 'underscore';
import React, { useCallback } from 'react';
import { useFormService } from '../core/form-service';
import { FORM_EVENTS, FORM_STATES } from '../machine/machine-config';

export const ViewContainer = React.memo(() => {
  const { state, send, config: dynamicConfig } = useFormService();
  const config = _.get(state, ['context', 'config']);
  const { view: View } = config;
  const { viewProps } = dynamicConfig;

  const currentData = _.get(state, ['context', 'data']);
  const currentError = _.get(state, ['context', 'error']);

  const onDataChange = useCallback(({ data, isValid }) => {
    send(FORM_EVENTS.CHANGE_DATA, { data, isValid });
  }, [send]);

  const isFetching = state.matches(FORM_STATES.FETCHING);

  if (isFetching) {
    return <div className="not-ready-view" />;
  }

  return (
    <View
      {...viewProps}
      data={currentData}
      error={currentError}
      onDataChange={onDataChange}
    />
  );
});
